<template>
  <div>
    <v-dialog v-model="SHOW" width="500" persistent>
      <v-card>
        <div class="header-icon-wrapper">
          <v-icon color="blue darken-2">mdi-account-multiple</v-icon>
        </div>
        <div class="wrapper-title">
          <h3>{{ $t("assignToInitiator") }}</h3>
        </div>
        <v-card-text>
          <v-select
            v-model="selectedUnitCode"
            :items="unitCodeItems"
            :label="$t('profile')"
            item-text="name"
            item-value="value"
            :no-data-text="$t('no_data_found')"
          ></v-select>
          <v-select
            v-model="selectedInitiatorId"
            :items="initiatorItems"
            :label="$t('initiator')"
            item-text="fullName"
            item-value="id"
            :loading="isRetrievingInitiatorList"
            :no-data-text="$t('no_data_found')"
          ></v-select>
        </v-card-text>
        <v-divider class="main-action-process-list-divider"></v-divider>
        <div class="process-main-actions">
          <v-btn large outlined color="primary" @click="onClickCancel">{{
            $t("cancel")
          }}</v-btn>
          <v-btn
            large
            color="primary"
            @click="onClickAssignToInitiator"
            :disabled="
              isRetrievingInitiatorList ||
                isAssignmentInProgress ||
                selectedInitiatorId === 0
            "
            :loading="isAssignmentInProgress"
            >{{ $t("assignToAppropriateInitiator") }}</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AssignToInitiatorDialog from "./mixin/AssignToInitiatorDialog";

export default {
  mixins: [AssignToInitiatorDialog]
};
</script>
<style lang="scss" scoped>
$primaryColor: #3fa2f7;

.header-icon-wrapper {
  text-align: center;
  padding-top: 20px;
  .v-icon {
    font-size: 3rem;
    padding: 25px;
    border-radius: 50%;
    border: 4px solid #3fa2f7;
  }
}
.wrapper-title {
  text-align: center;
  margin-top: 5%;
  color: $primaryColor;
}
.main-action-process-list-divider {
  margin-bottom: 5%;
}
.process-main-actions {
  text-align: center;
  padding-bottom: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/AssignToInitiatorDialog.vue